<template>
  <div class="formfooter">
    <div class="loginIsRegister">
      <span style="color: #84878D;cursor: pointer;" @click="retrieve">忘记密码</span>
      <a-divider type="vertical" />
      <span style="color:#84878D;cursor: pointer;" @click="resgoster">注册</span>
    </div>
    <div class="user-agreement">
      <p>登录或注册即代表同意乐私塾</p>
      <p
        style="color: #4B7DFD;cursor: pointer;"
        @click.stop="openLink('https://static.51lss.com/teamanager/agreement/lss_userAgreement.html')"
      >
        《用户协议》
      </p>
      <p>和</p>
      <p
        style="color: #4B7DFD;cursor: pointer;"
        @click.stop="openLink('https://static.51lss.com/teamanager/agreement/lss_privacyAgreement.html')"
      >
        《隐私协议》
      </p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  name: '',
  data() {
    return {}
  },
  methods: {
    openLink(link) {
      window.open(link)
    },
    retrieve() {
      this.$router.push({ name: 'forgotPwd', query: { ocode: Vue.ls.get('code') } })
    },
    resgoster() {
      this.$router.push({ name: 'register', query: { ocode: Vue.ls.get('code') } })
    },
    explain() {
      this.$router.push({ name: 'explain', query: { ocode: Vue.ls.get('code') } })
    }
  }
}
</script>
<style lang="less" scoped>
.formfooter {
  width: 370px;
}
.loginIsRegister {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 12px;
  width: 370px;
}
.user-agreement {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #9ea1a5;
  margin-bottom: 10px;
  margin-top: 24px;
}
</style>
